import React from 'react'
import agent from '../../../images/pic.png'

const Agent = () => {
  return (
    <div style={{backgroundColor: '#DFE1E1',overflowWrap:'break-word'}} className='py-2 text-center'>
      <p style={{fontWeight: '400'}}>You can talk to our agent on WhatsApp</p>
      
      <a href='https://wa.me/message/BK5S4G6RWZ3JF1'><img src={agent} alt='agent'/></a>
    </div>
  )
}

export default Agent
